import { select, getData, getHeight } from 'modules/dom'

const wrapper = select('.js-wrapper')
const header = select('.header', wrapper)

export default function (el) {
  const query = window.location.hash.replace('#','').toLowerCase()
  const conceptEl = select('[data-concept="' + query + '"]', el)
  if (conceptEl) {
    const heightHeader = getHeight(header)
    let scroll = conceptEl.getBoundingClientRect().top - heightHeader - 30
    if (window.innerWidth < 600) {
      scroll = scroll - 40
    }
    wrapper.scrollTop = scroll
  }
}
